import {Component, inject, OnDestroy, OnInit} from "@angular/core";
import {FormBuilder, Validators} from "@angular/forms";
import {Store} from "@ngrx/store";
import {map, Subscription} from "rxjs";
import {selectSelectedFundValuation} from "../../store/fund-valuation/fund-valuation.selectors";
import {FundValuationActions} from "../../store/fund.actions";
import {DecimalFormatPipe} from "../../../shared/pipes/decimal-format/decimal-format.pipe";

@Component({
    selector: "valumize-fund-management-settings-dialog",
    templateUrl: "./fund-management-fee-settings-dialog.component.html",
    styleUrls: ["./fund-management-fee-settings-dialog.component.scss"],
    standalone: false
})
export class FundManagementFeeSettingsDialogComponent implements OnInit, OnDestroy {
    private readonly store = inject(Store);
    private readonly formBuilder = inject(FormBuilder);

    subscriptions: Subscription[] = [];

    constructor( ) {}

    managementFeeSettingsForm = this.formBuilder.group({
        scalingFactor: this.formBuilder.control<number>(100, {nonNullable: true, validators:  [Validators.required, Validators.min(0), Validators.max(500)]})
    });

    speedOptions: number[] = [0, 5, 10, 15, 25, 40, 60, 75, 90, 95, 100, 105, 110, 125, 150, 200, 250, 300, 400, 450, 500];

    ngOnInit(): void {
        this.subscriptions.push(
            this.store.select(selectSelectedFundValuation).pipe(map(val => {
                this.managementFeeSettingsForm.patchValue({
                    scalingFactor: DecimalFormatPipe.transformFractionToPercent(val.data.managementFeeScale.fraction) ?? 100
                });
            })).subscribe()
        );
    }

    save() {
        const factor = DecimalFormatPipe.transformPercentToFraction(this.managementFeeSettingsForm.getRawValue().scalingFactor);

        if (this.managementFeeSettingsForm.valid && factor !== undefined) {
            this.store.dispatch(FundValuationActions.saveManagementFeeSettings({
                managementFeeScale: factor
            }));
        }
    }

    getSliderIndex(): number {
        const value = this.managementFeeSettingsForm.controls.scalingFactor.value ?? 100;
        return this.speedOptions.indexOf(value) !== -1 ? this.speedOptions.indexOf(value) : this.getNearestIndex(value);
    }

    getNearestIndex(value: number): number {
        return this.speedOptions.reduce((bestIdx, curr, idx) => {
            return Math.abs(curr - value) < Math.abs(this.speedOptions[bestIdx] - value) ? idx : bestIdx;
        }, 0);
    }

    onSliderChange(index: number): void {
        const newValue = this.speedOptions[index];
        this.managementFeeSettingsForm.controls.scalingFactor.setValue(newValue);
    }

    ngOnDestroy = () => this.subscriptions.forEach(subscription => subscription.unsubscribe());

}
